import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const MassiveEcheckColumns = () => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
            <I18n component="span" id="massiveEcheck.table.issueNumber" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1}>
            <I18n component="span" id="massiveEcheck.table.date" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1}>
            <I18n component="span" id="massiveEcheck.table.cuit" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1}>
            <I18n component="span" id="massiveEcheck.table.transmitter" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} rowStart={1} rowWidth={1}>
            <I18n component="span" id="lotPayment.new.state" />
        </GridTable.Data>
        <GridTable.Data columnStart={6} rowStart={1} rowWidth={1}>
            <I18n component="span" id="echecks.emit.motive.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={7} rowStart={1} rowWidth={1}>
            <I18n component="span" id="lotPayment.new.amount" />
        </GridTable.Data>
    </>
);

export default MassiveEcheckColumns;
